import React from "react";
import theme from "../../styles/theme";
import CardHome from "../../components/reusable/Card/CardHome";
import CardsContainer from "../../components/reusable/containers/CardsContainer";

const Home = () => {
  return (
    <div style={{ padding: 10 }}>
      {/* ===============================
          HERO SECTION
      =============================== */}
      <section
        className="hero-section"
        style={{ backgroundColor: "#fcfdff", marginTop: -20 }}
      >
        <img
          src="/assets/logos/corelia.png"
          alt="Quantum Corelia"
          className="hero-logo"
        />

        <h1
          className="hero-title"
          style={{ lineHeight: 1.5, paddingBottom: "1.5px" }}
        >
          Quantum Corelia
        </h1>

        <div
          className="hero-highlight"
          style={{
            lineHeight: 1.5,
            color: theme.colors.text.corelia,
            fontSize: theme.fontSizes.xxl,
            fontWeight: theme.fontWeights.normal,
            marginTop: "5px",
          }}
        >
          Définir, structurer et estimer un projet dès les premières esquisses.
        </div>

        <p className="hero-intro">
          Corelia fournit une base technique claire dès l’amont du projet :
          ouvrages, zones, systèmes, sous-systèmes, quantités et premières
          estimations.
          <br />
          Une approche simple à lire, rapide à exploiter et directement utile
          pour cadrer les études, préparer un APS et lancer le projet sur des
          bases cohérentes.
        </p>
      </section>

      {/* ===============================
          GRID FONCTIONNALITÉS
      =============================== */}
      <div
        className="cards-wrapper"
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(3, 360px)",
          justifyContent: "center",
          justifyItems: "center",
          gap: "24px",
          marginTop: "10px",
          marginBottom: "28px",
          backgroundColor: "#fcfdff",
          maxWidth: "1200px",
          marginLeft: "auto",
          marginRight: "auto",
          padding: "0 20px",
        }}
      >
        <CardHome
          title="Structurer le projet"
          description="Ouvrages, zones, systèmes et sous-systèmes sont organisés dès le départ dans une structure technique lisible."
          titleColor="#B8621B"
          width="360px"
          minWidth="360px"
          height="auto"
          minHeight="160px"
        />

        <CardHome
          title="Définir les solutions"
          description="Les solutions techniques de référence sont proposées selon le type de projet, le contexte et les usages attendus."
          titleColor="#B8621B"
          width="360px"
          minWidth="360px"
          height="auto"
          minHeight="160px"
        />

        <CardHome
          title="Estimer rapidement"
          description="Quantités conceptuelles, articles de prix et premières enveloppes budgétaires sont établis à partir d’un modèle simple."
          titleColor="#B8621B"
          width="360px"
          minWidth="360px"
          height="auto"
          minHeight="160px"
        />

        <CardHome
          title="Préparer l’APS"
          description="Le projet dispose rapidement d’une base exploitable pour les notes, les pièces techniques et le dossier d’appel d’offres."
          titleColor="#B8621B"
          width="360px"
          minWidth="360px"
          height="auto"
          minHeight="160px"
        />

        <CardHome
          title="Lancer les études sur un cadre clair"
          description="Les études détaillées démarrent sur une logique déjà posée, avec moins d’ambiguïtés, moins de ressaisie et plus de cohérence."
          titleColor="#B8621B"
          width="360px"
          minWidth="360px"
          height="auto"
          minHeight="160px"
        />

        <CardHome
          title="Préparer la modélisation"
          description="La logique technique du projet est définie en amont, ce qui facilite ensuite les études détaillées et la production des modèles."
          titleColor="#B8621B"
          width="360px"
          minWidth="360px"
          height="auto"
          minHeight="160px"
        />
      </div>

      {/* ===============================
          QUOTE PREMIUM
      =============================== */}
      <div
        className="hero-highlight"
        style={{
          color: theme.colors.text.caneva,
          fontWeight: theme.fontWeights.normal,
          fontSize: theme.fontSizes.xl,
          letterSpacing: "0.6px",
          textAlign: "center",
          margin: "40px auto 35px",
          padding: "16px 0",
          width: "65%",
          borderTop: `1px solid ${theme.colors.text.caneva}33`,
          borderBottom: `1px solid ${theme.colors.text.caneva}33`,
        }}
      >
        “Un projet bien structuré se décide plus vite, se chiffre plus juste et s’étudie mieux.”
      </div>

      {/* ===============================
          SECTION 1
      =============================== */}
      <CardsContainer justify="center" align="center" gap={0}>
        <div
          style={{
            width: "1000px",
            minWidth: "1000px",
            height: "auto",
            minHeight: "320px",
            backgroundColor: "transparent",
            borderRadius: "0px",
            border: "1px solid #e2e8f0",
            padding: "24px",
            boxShadow: "0 4px 6px rgba(0,0,0,0.07)",
            marginBottom: 28,
          }}
        >
          <h2 className="section-title">
            Structurer le projet avant de le détailler
          </h2>

          <p className="intro" style={{ color: theme.colors.text.green }}>
            Une base simple, technique et directement exploitable.
          </p>

          <ul className="section-list">
            <li>
              Le projet est organisé par ouvrages, zones, systèmes et
              sous-systèmes dès les premières phases.
            </li>
            <li>
              Les solutions techniques courantes sont posées sans attendre les
              études détaillées.
            </li>
            <li>
              Les premières quantités et estimations reposent sur une structure
              claire et vérifiable.
            </li>
          </ul>

          <div>
            Corelia apporte{" "}
            <strong style={{ color: theme.colors.text.caneva }}>
              un cadre technique lisible dès l’amont
            </strong>{" "}
            pour réduire l’incertitude, accélérer les décisions et poser une
            base cohérente pour la suite du projet.
          </div>

          <div className="section-logo" style={{ marginTop: "15px" }}>
            <img
              src="/assets/logos/corelia.png"
              alt="Corelia Badge"
              style={{ width: 30 }}
            />
          </div>
        </div>
      </CardsContainer>

      {/* ===============================
          SECTION 2
      =============================== */}
      <CardsContainer justify="center" align="center" gap={0}>
        <div
          style={{
            width: "1000px",
            minWidth: "1000px",
            height: "auto",
            minHeight: "320px",
            backgroundColor: "transparent",
            borderRadius: "0px",
            border: "1px solid #e2e8f0",
            padding: "24px",
            boxShadow: "0 4px 6px rgba(0,0,0,0.07)",
            marginBottom: 28,
          }}
        >
          <h2 className="section-title">
            Une base technique exploitable dès les premières phases
          </h2>

          <p className="intro" style={{ color: theme.colors.text.green }}>
            Définir, estimer et préparer sans alourdir le travail.
          </p>

          <ul className="section-list">
            <li>
              Une organisation claire pour cadrer rapidement un immeuble, un
              ouvrage technique ou un petit projet AEP.
            </li>
            <li>
              Des solutions techniques de référence mobilisables sans repartir
              de zéro à chaque projet.
            </li>
            <li>
              Une première base pour les quantités, l’estimation, les pièces
              techniques et le lancement des études.
            </li>
          </ul>

          <div>
            Corelia{" "}
            <strong style={{ color: theme.colors.text.caneva }}>
              transforme les premières hypothèses en base projet exploitable
            </strong>
            , avec une logique technique stable et directement utile aux équipes
            d’ingénierie.
          </div>

          <div className="section-logo" style={{ marginTop: "15px" }}>
            <img
              src="/assets/logos/corelia.png"
              alt="Corelia Badge"
              style={{ width: 30 }}
            />
          </div>
        </div>
      </CardsContainer>

      {/* ===============================
          SECTION 3
      =============================== */}
      <CardsContainer justify="center" align="center" gap={0}>
        <div
          style={{
            width: "1000px",
            minWidth: "1000px",
            height: "auto",
            minHeight: "320px",
            backgroundColor: "transparent",
            borderRadius: "0px",
            border: "1px solid #e2e8f0",
            padding: "24px",
            boxShadow: "0 4px 6px rgba(0,0,0,0.07)",
          }}
        >
          <h2 className="section-title">
            Un projet plus clair, plus rapide à lancer, plus simple à faire
            avancer
          </h2>

          <p className="intro" style={{ color: theme.colors.text.green }}>
            Lorsque la structure est claire, les études avancent mieux.
          </p>

          <ul className="section-list">
            <li>
              Préparation plus rapide des dossiers APS et des premières pièces
              d’appel d’offres.
            </li>
            <li>
              Meilleure cohérence entre organisation spatiale, solutions
              techniques et estimation.
            </li>
            <li>
              Base plus stable pour les études détaillées, les documents et la
              modélisation.
            </li>
            <li>
              Moins de ressaisie, moins d’ambiguïtés et moins de reprises
              inutiles.
            </li>
            <li>
              Une lecture plus immédiate du projet pour les équipes, les
              partenaires et les décideurs.
            </li>
          </ul>

          <div>
            Corelia{" "}
            <strong style={{ color: theme.colors.text.caneva }}>
              donne au projet une base technique solide avant qu’il ne se
              disperse dans les études et les documents.
            </strong>
          </div>

          <div className="section-logo" style={{ marginTop: "15px" }}>
            <img
              src="/assets/logos/corelia.png"
              alt="Corelia Badge"
              style={{ width: 30 }}
            />
          </div>
        </div>
      </CardsContainer>
    </div>
  );
};

export default Home;